import { axiosClient } from './axiosClient';

export const dashboardApi = {
  getTopCounts: () => {
    const url = '/top/counts';
    return axiosClient.get(url);
  },
  getCanceledReservations: (date?: string) => {
    const url = '/top/counts/canceled_reservation';
    return axiosClient.get(url, {
      params: date ? { date } : undefined,
    });
  },
  getPendingSurveys: (date?: string) => {
    const url = '/top/counts/pending_survey';
    return axiosClient.get(url, {
      params: date ? { date } : undefined,
    });
  },
  getLowReservationRates: () => {
    const url = '/top/counts/low_reservation_rate';
    return axiosClient.get(url);
  },
  getEventProgress: (params: { search?: string; page?: number; perPage?: number } = {}) => {
    const url = '/top/event-progress';
    return axiosClient.get(url, {
      params: {
        ...(params.search ? { search: params.search } : {}),
        ...(params.page ? { page: params.page } : {}),
        ...(params.perPage ? { perPage: params.perPage } : {}),
      },
    });
  },
  getInterviewProgress: (
    params: { date?: string; search?: string; page?: number; perPage?: number } = {},
  ) => {
    const url = '/top/interview-progress';
    return axiosClient.get(url, {
      params: {
        ...(params.date ? { date: params.date } : {}),
        ...(params.search ? { search: params.search } : {}),
        ...(params.page ? { page: params.page } : {}),
        ...(params.perPage ? { perPage: params.perPage } : {}),
      },
    });
  },
  getConsultantAvailability: (
    params: {
      month?: number;
      year?: number;
      search?: string;
      page?: number;
      perPage?: number;
      orderBy?: ('interviewCount' | 'openSlots')[];
    } = {},
  ) => {
    const url = '/top/consultant-availability';
    return axiosClient.get(url, {
      params: {
        ...(params.month ? { month: params.month } : {}),
        ...(params.year ? { year: params.year } : {}),
        ...(params.search ? { search: params.search } : {}),
        ...(params.page ? { page: params.page } : {}),
        ...(params.perPage ? { perPage: params.perPage } : {}),
        ...(params.orderBy ? { orderBy: params.orderBy.join(',') } : {}),
      },
    });
  },
};
